import React from "react";

const ClientsSection = () => {
  const clients = [
    {
      name: "SKK Migas",
      logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/64/Logo_of_SKK_Migas.svg/1200px-Logo_of_SKK_Migas.svg.png",
      description: "Satuan Kerja Khusus Pelaksana Kegiatan Usaha Hulu Minyak dan Gas Bumi"
    },
    {
      name: "Pertamina",
      logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQl0oG5uN_mYl27jtggU2vo1snqwpUF6wbFQw&s",
      description: "PT Pertamina (Persero)"
    },
    {
      name: "UNESCO-IHE Delft",
      logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ0hYNRBh34arZyH4sQ2DWGRv-a0RF66bUr0Q&s",
      description: "UNESCO-IHE Institute for Water Education"
    },
    {
      name: "Inovasia",
      logo: "https://inovasia.net/images/LOGO_INOVASIA_craft_Miniatuur.png",
      description: "PT Inovasi Asia"
    },
    {
      name: "Treasury Tower Office",
      logo: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjgwIiB2aWV3Qm94PSIwIDAgMjAwIDgwIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cmVjdCB3aWR0aD0iMjAwIiBoZWlnaHQ9IjgwIiBmaWxsPSIjNEY0NjRGIi8+Cjx0ZXh0IHg9IjIwIiB5PSIzNSIgZm9udC1mYW1pbHk9IkFyaWFsLCBzYW5zLXNlcmlmIiBmb250LXNpemU9IjE0IiBmaWxsPSJ3aGl0ZSIgZm9udC13ZWlnaHQ9ImJvbGQiPlRyZWFzdXJ5PC90ZXh0Pgo8dGV4dCB4PSIyMCIgeT0iNTUiIGZvbnQtZmFtaWx5PSJBcmlhbCwgc2Fucy1zZXJpZiIgZm9udC1zaXplPSIxMiIgZmlsbD0id2hpdGUiPlRvd2VyIE9mZmljZTwvdGV4dD4KPC9zdmc+Cg==",
      description: "Treasury Tower Office Senayan"
    },
    {
      name: "Bank Mandiri",
      logo: "https://yt3.googleusercontent.com/Q8eQPjBgeQyBnOjb6Ve49uOVdFDqWgFiuN2hcrJmMJekSvB-5jNkKL3lC0zq60DPN9-whAR14g=s900-c-k-c0x00ffffff-no-rj",
      description: "PT Bank Mandiri (Persero) Tbk"
    }
  ];

  return (
    <section id="clients" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <div className="text-center mb-16">
            <span className="inline-block px-4 py-2 bg-blue-100 text-blue-700 rounded-full text-sm font-semibold mb-4">
              Klien & Partner
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Dipercaya oleh <span className="text-gradient-blue-orange">Perusahaan Terkemuka</span>
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Kami bangga telah menjalin kerjasama dengan berbagai perusahaan ternama dan institusi bergengsi.
            </p>
          </div>

          {/* Clients Grid */}
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 items-center">
            {clients.map((client, index) => (
              <div
                key={index}
                className="group flex flex-col items-center p-6 bg-gray-50 rounded-2xl hover:bg-white hover:shadow-lg transition-all duration-300 hover-lift"
              >
                <div className="w-full h-20 flex items-center justify-center mb-4 grayscale group-hover:grayscale-0 transition-all duration-300">
                  <img
                    src={client.logo}
                    alt={`Logo ${client.name} - ${client.description}, klien RanselPro untuk layanan multimedia`}
                    className="max-w-full max-h-full object-contain"
                    loading="lazy"
                  />
                </div>
                <h3 className="text-sm font-semibold text-gray-900 text-center group-hover:text-blue-600 transition-colors duration-300">
                  {client.name}
                </h3>
              </div>
            ))}
          </div>

          {/* Trust Indicators */}
          <div className="mt-16 bg-gradient-to-r from-blue-50 to-orange-50 rounded-3xl p-8 md:p-12">
            <div className="grid md:grid-cols-3 gap-8 text-center">
              <div>
                <div className="text-3xl font-bold text-blue-600 mb-2">100%</div>
                <div className="text-gray-700 font-medium">Client Satisfaction</div>
                <div className="text-sm text-gray-600 mt-1">Tingkat kepuasan klien tertinggi</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-orange-600 mb-2">24/7</div>
                <div className="text-gray-700 font-medium">Support Available</div>
                <div className="text-sm text-gray-600 mt-1">Dukungan teknis sepanjang waktu</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-blue-600 mb-2">On-Time</div>
                <div className="text-gray-700 font-medium">Project Delivery</div>
                <div className="text-sm text-gray-600 mt-1">Penyelesaian project tepat waktu</div>
              </div>
            </div>
          </div>

          {/* Partnership CTA */}
          <div className="mt-16 text-center">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Ingin Menjadi Partner Kami?
            </h3>
            <p className="text-gray-600 mb-6 max-w-2xl mx-auto">
              Bergabunglah dengan perusahaan-perusahaan terkemuka yang telah mempercayakan kebutuhan multimedia mereka kepada kami.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClientsSection;